"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";

export default function Disclaimer() {
  return (
    <div className="min-h-screen bg-transparent" dir="rtl">
      <div className="container w-full">
        {/* Return Button */}
        <div className="mb-6">
          <Button
            variant="outline"
            className="flex items-center gap-2 hover:bg-gray-100 bg-transparent"
            onClick={() => window.history.back()}>
            <ArrowRight className="h-4 w-4" />
            חזרה לעמוד הקודם
          </Button>
        </div>

        {/* Main Article */}
        <Card className="border-none shadow-none bg-transparent">
          <CardContent>
            {/* Header */}
            <div className="text-center mb-8 border-b pb-6">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">כתב ויתור ותנאי שימוש</h1>
              <p className="text-xl text-gray-600 mb-2">מערכת ZoooZ</p>
              <p className="text-sm text-gray-500">עודכן: 9 ביולי 2025</p>
            </div>

            {/* Content Sections */}
            <div className="space-y-8 ">
              {/* Section 1 */}
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4 border-b-2 border-blue-100 pb-2">1. הגדרות</h2>
                <div className="space-y-3 text-gray-700 leading-relaxed">
                  <p>
                    <strong>המערכת / השירות</strong> – אפליקציית ZoooZ וכל שירות מקוון נלווה.
                  </p>
                  <p>
                    <strong>לקוח / משתמש</strong> – עמותה, עובדיה או מורשיה שקיבלו הרשאה לגישה למערכת.
                  </p>
                  <p>
                    <strong>מידע</strong> – כל נתון, לרבות פרטים אישיים, פיננסיים ורגישים, המוצגים במערכת.
                  </p>
                  <p>
                    <strong>שימוש מסחרי</strong> – כל שימוש במידע לשם הפקת רווחים כספיים או העברתו לצד שלישי, שאינו
                    לצורך גיוס תרומה ספציפית לעמותה.
                  </p>
                </div>
              </section>

              {/* Section 2 */}
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4 border-b-2 border-blue-100 pb-2">
                  2. רישיון שימוש מוגבל
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  החברה מעניקה ללקוח רישיון אישי, לא-בלעדי, בלתי-עביר, מוגבל בזמן ולמטרה, להשתמש במערכת אך ורק לצורך
                  איתור ותפעול קשרי תרומה עבור העמותה. כל שימוש אחר, לרבות ייצוא, העתקה סיטונאית, כרייה (Data Mining) או
                  העברת המידע לצדדים שלישיים – אסור.
                </p>
              </section>

              {/* Section 3 */}
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4 border-b-2 border-blue-100 pb-2">
                  3. מגבלות שימוש טכניות והתנהגותיות
                </h2>
                <div className="space-y-4 text-gray-700 leading-relaxed">
                  <div>
                    <h3 className="font-semibold mb-2">תקרת בקשות:</h3>
                    <p>
                      גישה לנתונים אישיים על חברות ואנשי קשר מוגבלת ל-100 חיפושים/צפיות בחודש קלנדרי לכל עמותה. חריגה
                      תיחשב פעילות חשודה החברה רשאית להקפיא או לחסום את החשבון לאלתר.
                    </p>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">איסור שאיבה:</h3>
                    <p>
                      כל ניסיון אוטומטי להוריד, לגרד (Scrape) או להעתיק את בסיס הנתונים, כולו או חלקו, מהווה הפרה יסודית
                      של תנאי השימוש.
                    </p>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">איסור העברה לצד ג׳:</h3>
                    <p>
                      חל איסור מוחלט למכור, להשכיר, להעמיד, או להעביר כל מידע מהמערכת לכל גורם אחר – לרבות עמותות אחיות,
                      יועצים, חברות ניהול וכו׳.
                    </p>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">אבטחת חשבון:</h3>
                    <p>המשתמש אחראי לשמור את פרטי הגישה בסוד. אובדן/גניבה יש לדווח מיד.</p>
                  </div>
                </div>
              </section>

              {/* Section 4 */}
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4 border-b-2 border-blue-100 pb-2">
                  4. קניין רוחני
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  כל זכויות הקניין הרוחני (DB schema, קוד, תוכן, עיצוב, לוגואים וכד׳) שמורות לחברה (עוסק מורשה ישראלי).
                  אין להעתיק, לפרסם, לשדר, לתרגם, או לבצע יצירות נגזרות ללא היתר בכתב.
                </p>
              </section>

              {/* Section 5 */}
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4 border-b-2 border-blue-100 pb-2">
                  5. הגנת הפרטיות ואבטחת מידע
                </h2>
                <div className="text-gray-700 leading-relaxed space-y-3">
                  <p>החברה פועלת בהתאם ל-</p>
                  <ul className="list-disc list-inside space-y-2 mr-4">
                    <li>חוק הגנת הפרטיות, התשמ״א-1981, תקנות אבטחת מידע 2017, והנחיות רשות הגנת הפרטיות</li>
                    <li>
                      תיקון מס׳ 13 לחוק (נכנס לתוקף 14.8.2025) בדבר חובות אבטחה מוגברות, מינוי ממונה פרטיות ורישום מאגרי
                      מידע.
                    </li>
                  </ul>
                  <p>החברה מיישמת אמצעי אבטחה פיזיים, לוגיים וארגוניים לפי רמת האבטחה המחמירה שנקבעה בתקנות.</p>
                </div>
              </section>

              {/* Section 6 */}
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4 border-b-2 border-blue-100 pb-2">
                  6. שיווק והתראות ("דברי שירות")
                </h2>
                <div className="space-y-4 text-gray-700 leading-relaxed">
                  <div>
                    <h3 className="font-semibold mb-2">הסכמה מפורשת (OPT-IN):</h3>
                    <p>
                      בהשלמת הרישום מצהיר המשתמש כי נתן לחברה רשות לשלוח הודעות דוא״ל ו/או SMS בנושאי עדכונים, הזדמנויות
                      תרומה ותפעול השירות.
                    </p>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">זכות ביטול (OPT-OUT):</h3>
                    <p>
                      כל הודעה תכלול קישור/הנחיה להפסקת קבלת הודעות הבקשה תטופל עד 3 ימי עסקים, בהתאם לסעיף 30א לחוק
                      התקשורת (בזק ושידורים) ("חוק הספאם") והתיקונים החלים.
                    </p>
                  </div>
                  <div>
                    <p>
                      החברה אינה שולחת דברי פרסומת בלתי מבוקשים כל מסר מוגדר "מסר שירותי" או "מידע מקצועי" לניהול
                      התרמות.
                    </p>
                  </div>
                </div>
              </section>

              {/* Section 7 */}
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4 border-b-2 border-blue-100 pb-2">
                  7. הצהרת אי-אחריות
                </h2>
                <div className="space-y-4 text-gray-700 leading-relaxed">
                  <div>
                    <h3 className="font-semibold mb-2">דיוק המידע:</h3>
                    <p>
                      המידע נאסף ממקורות גלויים ומעודכן מפעם לפעם. החברה אינה מתחייבת לדיוק, שלמות, או עדכניות מוחלטת של
                      הנתונים, ולא תישא באחריות לנזק ישיר או עקיף שייגרם מהסתמכות עליהם.
                    </p>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">שימוש אסור:</h3>
                    <p>
                      כל שימוש שאינו בהתאם לסעיפים 2–3 עלול להוות הפרת זכויות צד ג׳, הפרת פרטיות ואף עבירה פלילית.
                      המשתמש מתחייב לשפות את החברה בגין כל נזק, תביעה או הוצאה שייגרמו עקב שימושו הבלתי מורשה.
                    </p>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">הגבלת אחריות:</h3>
                    <p>
                      בכל מקרה, אחריות החברה תוגבל לסכום התקבולים ששולמו בפועל על-ידי הלקוח ב-12 החודשים שקדמו לאירוע.
                    </p>
                  </div>
                </div>
              </section>

              {/* Section 8 */}
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4 border-b-2 border-blue-100 pb-2">
                  8. ניטור, אכיפה וסנקציות
                </h2>
                <div className="text-gray-700 leading-relaxed space-y-3">
                  <p>
                    החברה שומרת לעצמה את הזכות לנטר פעילות מערכתית, לייצר לוגים ולנתחם לצורכי אבטחת מידע, עמידה בדין
                    והגבלת שימושים אסורים. זוהתה חריגה – החברה רשאית:
                  </p>
                  <ul className="list-disc list-inside space-y-1 mr-4">
                    <li>לדרוש הסברים בכתב</li>
                    <li>להשעות/לבטל גישה</li>
                    <li>לדווח לרשויות אכיפה (רשות הגנת הפרטיות, רשות ני״ע ועוד).</li>
                  </ul>
                </div>
              </section>

              {/* Section 9 */}
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4 border-b-2 border-blue-100 pb-2">
                  9. שינויים בתנאים
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  החברה רשאית לעדכן את כתב הוויתור מעת לעת. עדכון מהותי יישלח למשתמשים 30 יום מראש במייל. המשך שימוש
                  לאחר מועד התחולה יהווה קבלת התנאים.
                </p>
              </section>

              {/* Section 10 */}
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4 border-b-2 border-blue-100 pb-2">
                  10. דין וסמכות שיפוט
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  הדין החל – דיני מדינת ישראל. סמכות שיפוט ייחודית – בתי המשפט המוסמכים במחוז תל-אביב-יפו.
                </p>
              </section>

              {/* Section 11 */}
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4 border-b-2 border-blue-100 pb-2">
                  11. יצירת קשר
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  שאלות בנוגע לתנאים, לפרטיות או לבקשות הסרה מרשימת הדיוור ניתן להפנות ל-
                  <a href="mailto:info@zoooz.co" className="text-blue-600 hover:text-blue-800 underline">
                    info@zoooz.co
                  </a>
                </p>
              </section>

              {/* Final Statement */}
              <div className="bg-blue-50 border-r-4 border-blue-400 p-6 rounded-lg mt-8">
                <p className="text-blue-800 font-medium text-center">
                  בעת רישום למערכת, המשתמש מאשר כי קרא את כתב הוויתור, מבין את תוכנו ומסכים לתנאיו.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Bottom Return Button */}
        <div className="mt-8 text-center">
          <Button
            variant="outline"
            size="lg"
            className="flex items-center gap-2 mx-auto hover:bg-gray-100 bg-transparent"
            onClick={() => window.history.back()}>
            <ArrowRight className="h-4 w-4" />
            חזרה לעמוד הקודם
          </Button>
        </div>
      </div>
    </div>
  );
}
